import { useState, useEffect, useCallback } from "react";
import "./map.css";
import Map2D from "./Map2D";
import Map3D from "./Map3D";
import MapControls from "./MapControls";
import { getRelationshipTypes } from "../../services/innovatorApi";

const Map = () => {
  const [viewMode, setViewMode] = useState("2d"); // '2d' or '3d'
  const [relationshipTypes, setRelationshipTypes] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");

  useEffect(() => {
    // Load relationship types on mount (only if not already loaded by Map3D)
    if (relationshipTypes.length === 0) {
      getRelationshipTypes()
        .then((types) => {
          setRelationshipTypes(types);
        })
        .catch((error) => {
          console.error("Error loading relationship types:", error);
        });
    }
  }, []); // Only run once on mount

  const handleFilterChange = useCallback((value) => {
    setSelectedFilter(value);
  }, []);

  const handleRelationshipTypesUpdate = useCallback((key, types) => {
    if (key === "relationshipTypes" && Array.isArray(types) && types.length > 0) {
      setRelationshipTypes((prev) => {
        // Only update if different to prevent unnecessary re-renders
        if (JSON.stringify(prev) !== JSON.stringify(types)) {
          return types;
        }
        return prev;
      });
    }
  }, []);

  const toggleViewMode = () => {
    setViewMode((prev) => (prev === "2d" ? "3d" : "2d"));
  };

  return (
    <div className="map-wrapper" style={{ position: "relative", width: "100%", height: "calc(100vh - 10rem)" }}>
      {/* View Switcher Button */}
      <button
        className="view-switcher-button"
        onClick={toggleViewMode}
        aria-label={`Switch to ${viewMode === "2d" ? "3D" : "2D"} view`}
      >
        {viewMode === "2d" ? "3D" : "2D"}
      </button>

      {/* Map Controls (only show in 3D view) */}
      {viewMode === "3d" && (
        <MapControls
          relationshipTypes={relationshipTypes}
          onFilterChange={handleFilterChange}
          selectedFilter={selectedFilter}
        />
      )}

      {/* Conditional Map Rendering */}
      {viewMode === "2d" ? (
        <Map2D />
      ) : (
        <Map3D onFilterChange={handleRelationshipTypesUpdate} selectedFilter={selectedFilter} />
      )}
    </div>
  );
};

export default Map;
